import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { api } from "@/lib/api";

export function useAccountApiKeys() {
  return useQuery({
    queryKey: ["account", "api-keys"],
    queryFn: () => api.listAccountApiKeys(),
    staleTime: 30_000,
  });
}

export function useCreateAccountApiKey() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: api.createAccountApiKey,
    onSuccess: () => qc.invalidateQueries({ queryKey: ["account", "api-keys"] }),
  });
}

export function useRevokeAccountApiKey() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: api.revokeAccountApiKey,
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["account", "api-keys"] });
      toast.success("API key revocada");
    },
  });
}

export function useDeleteAccountApiKey() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: api.deleteAccountApiKey,
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["account", "api-keys"] });
      toast.success("API key eliminada");
    },
  });
}
